module.exports = __webpack_public_path__ + "static/media/step-3.57f5e397.svg";